let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("qYLgW")).then(() => parcelRequire('hW3z1'));